<template>
    <svg
        height="24px"
        width="24px"
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 120.000000 120.000000"
        preserveAspectRatio="xMidYMid meet"
    >
        <metadata>Created by potrace 1.16, written by Peter Selinger 2001-2019</metadata>
        <g
            transform="translate(0.000000,120.000000) scale(0.100000,-0.100000)"
            style="fill: currentColor"
            stroke="none"
        >
            <path
                d="M185 1021 c-45 -10 -86 -21 -93 -25 -7 -4 -12 -23 -12 -42 0 -21 -8
-42 -20 -54 -19 -19 -20 -33 -20 -360 0 -327 1 -341 20 -360 19 -19 33 -20
240 -20 207 0 221 -1 240 -20 13 -13 33 -20 60 -20 27 0 47 7 60 20 19 19 33
20 240 20 207 0 221 1 240 20 19 19 20 33 20 360 0 327 -1 341 -20 360 -12 12
-20 33 -20 55 0 42 -10 47 -122 70 -100 19 -212 19 -315 -1 -76 -15 -88 -15
-163 0 -101 20 -231 19 -335 -3z m310 -84 l60 -13 3 -313 2 -312 -47 8 c-63
11 -245 10 -306 -1 l-47 -8 2 313 3 314 55 11 c74 16 201 16 275 1z m480 0
l60 -13 3 -313 2 -312 -47 8 c-63 11 -245 10 -306 -1 l-47 -8 2 313 3 314 55
11 c74 16 201 16 275 1z"
            />
            <path
                d="M800 863 c0 -10 -16 -27 -38 -38 -67 -36 -75 -130 -15 -170 16 -12
56 -27 87 -34 66 -15 81 -35 46 -63 -28 -23 -66 -17 -92 12 -10 13 -29 20 -52
20 -31 0 -36 -3 -36 -24 0 -27 43 -74 77 -82 14 -4 23 -14 23 -25 0 -15 7 -19
40 -19 31 0 40 4 40 18 0 10 16 24 39 35 43 19 61 51 61 106 0 49 -28 76 -100
95 -80 21 -90 26 -90 47 0 42 90 46 106 4 4 -10 20 -15 46 -15 36 0 39 2 33
23 -12 39 -33 64 -64 77 -19 8 -31 20 -31 31 0 15 -8 19 -40 19 -31 0 -40 -4
-40 -17z"
            />
        </g>
    </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "oss-general-ledger",
});
</script>
